if (!customElements.get('multi-buy-offer')) {
  class MultiBuyOffer extends HTMLElement {
    connectedCallback() {
      this.setSize = parseInt(this.dataset.setSize, 10) || 1;
      this.progressTemplateFirst = this.dataset.progressTemplateFirst || 'Add [remaining] more to unlock the offer';
      this.progressTemplateRepeat = this.dataset.progressTemplateRepeat || 'Add [remaining] more to unlock another set';
      this.stripTemplateSingular = this.dataset.stripTemplateSingular || "You've unlocked 1 set!";
      this.stripTemplatePlural = this.dataset.stripTemplatePlural || "You've unlocked [count] sets!";
      this.initialSubtext = this.dataset.initialSubtext || '';
      this.cartAddUrl = this.dataset.cartAddUrl || '/cart/add.js';
      this.cartUrl = this.dataset.cartUrl || '/cart.js';
      this.storageKey = this.dataset.storageKey || 'multi-buy-offer';
      this.removeLabel = this.dataset.removeLabel || 'Remove';
      this.addLabel = this.dataset.addLabel || 'Add';
      this.soldOutLabel = this.dataset.soldOutLabel || 'Sold out';
      this.stockLimitTemplate = this.dataset.stockLimitLabel || 'Only [max] left in stock';
      this.atcErrorText = this.dataset.atcErrorText || "Some items couldn't be added due to limited availability. Please adjust the quantity and try again.";
      this.setPriceCents = parseInt(this.dataset.setPriceCents, 10) || 0;
      this.savingsTemplate = this.dataset.savingsTemplate || 'You save [amount]!';
      this.cartGroupKey = this.dataset.cartGroupKey || '';
      this.collectionId = this.dataset.collectionId || '';
      this.collectionHandle = this.dataset.collectionHandle || '';
      this.cartGroupBg = this.dataset.cartGroupBg || '';
      this.cartGroupMessageFirst = this.dataset.cartGroupMessageFirst || '';
      this.cartGroupMessageRepeat = this.dataset.cartGroupMessageRepeat || '';
      this.cartGroupMessageSingular = this.dataset.cartGroupMessageSingular || '';
      this.cartGroupMessagePlural = this.dataset.cartGroupMessagePlural || '';
      this.cartGroupRedirectUrl = this.dataset.cartGroupRedirectUrl || '';
      this.leaveGuardEnabled = this.dataset.leaveGuardEnabled === 'true';
      this.leaveGuardTitleText = this.dataset.leaveGuardTitle || '';
      this.leaveGuardMessageTemplate = this.dataset.leaveGuardMessage || '';
      this.leaveGuardYesLabel = this.dataset.leaveGuardYesLabel || 'Yes';
      this.leaveGuardNoLabel = this.dataset.leaveGuardNoLabel || 'No';

      this.grid = this.querySelector('[data-mbo-grid]');
      this.panel = this.querySelector('[data-mbo-panel]');
      this.list = this.querySelector('[data-mbo-list]');
      this.emptyState = this.querySelector('[data-mbo-empty-state]');
      this.subtextEl = this.querySelector('[data-mbo-subtext]');
      this.progressFill = this.querySelector('[data-mbo-progress-fill]');
      this.strip = this.querySelector('[data-mbo-strip]');
      this.summaryEl = this.querySelector('[data-mbo-summary]');
      this.summaryCompareRowEl = this.querySelector('[data-mbo-summary-compare-row]');
      this.summaryCompareEl = this.querySelector('[data-mbo-summary-compare]');
      this.summaryTotalEl = this.querySelector('[data-mbo-summary-total]');
      this.summarySavingsEl = this.querySelector('[data-mbo-summary-savings]');
      this.atcButton = this.querySelector('[data-mbo-atc]');
      this.atcErrorEl = this.querySelector('[data-mbo-atc-error]');
      this.toggle = this.querySelector('[data-mbo-toggle]');

      this.leaveGuardEl = this.querySelector('[data-mbo-leave-guard]');
      this.leaveGuardDialogEl = this.querySelector('[data-mbo-leave-guard-dialog]');
      this.leaveGuardTitleEl = this.querySelector('[data-mbo-leave-guard-title]');
      this.leaveGuardMessageEl = this.querySelector('[data-mbo-leave-guard-message]');
      this.leaveGuardYesBtn = this.querySelector('[data-mbo-leave-guard-yes]');
      this.leaveGuardNoBtn = this.querySelector('[data-mbo-leave-guard-no]');
      this.pendingLeaveGuardUrl = '';
      this.leaveGuardBusy = false;
      this.leaveGuardLastFocusedEl = null;

      this.items = new Map();

      this._restore();

      this._onClick = this._onClick.bind(this);
      this._onAddToCart = this._onAddToCart.bind(this);

      this.addEventListener('click', this._onClick);
      if (this.atcButton) this.atcButton.addEventListener('click', this._onAddToCart);

      // Re-syncs already-selected quantities onto cards an infinite-scroll
      // fetch injects later - a card can't reflect the selection Map until
      // it actually exists in the DOM.
      this._onCardsAppended = this._render.bind(this);
      this.addEventListener('infinite-scroll:appended', this._onCardsAppended);

      if (this.leaveGuardEnabled && this.leaveGuardEl) {
        this._onDocumentClickForLeaveGuard = this._onDocumentClickForLeaveGuard.bind(this);
        this._onDocumentCaptureForLeaveGuard = this._onDocumentCaptureForLeaveGuard.bind(this);
        this._onLeaveGuardYes = this._resolveLeaveGuard.bind(this, true);
        this._onLeaveGuardNo = this._resolveLeaveGuard.bind(this, false);
        this._onLeaveGuardKeydown = this._onLeaveGuardKeydown.bind(this);
        this._onLeaveGuardOverlayClick = this._onLeaveGuardOverlayClick.bind(this);

        if (this.leaveGuardTitleEl) this.leaveGuardTitleEl.textContent = this.leaveGuardTitleText;
        if (this.leaveGuardYesBtn) this.leaveGuardYesBtn.textContent = this.leaveGuardYesLabel;
        if (this.leaveGuardNoBtn) this.leaveGuardNoBtn.textContent = this.leaveGuardNoLabel;

        // Bubble phase (not capture) is deliberate: any existing handler bound
        // directly to the clicked link (cart/nav drawer triggers, ajax filter
        // "remove tag" chips, etc.) already fires and calls preventDefault()
        // before this document-level listener sees the event, so this only
        // ever reacts to links that are genuinely about to navigate the page.
        document.addEventListener('click', this._onDocumentClickForLeaveGuard);
        // Capture phase, deliberately: see _onDocumentCaptureForLeaveGuard -
        // this one has to run before the theme's own <summary> click
        // handler, not after it.
        document.addEventListener('click', this._onDocumentCaptureForLeaveGuard, true);
        if (this.leaveGuardYesBtn) this.leaveGuardYesBtn.addEventListener('click', this._onLeaveGuardYes);
        if (this.leaveGuardNoBtn) this.leaveGuardNoBtn.addEventListener('click', this._onLeaveGuardNo);
        this.leaveGuardEl.addEventListener('keydown', this._onLeaveGuardKeydown);
        // Clicking the backdrop dismisses the popup - it's a click on the
        // outer wrapper itself (or the overlay) that never reaches the
        // dialog box, so this only ever fires for a genuine outside click.
        this.leaveGuardEl.addEventListener('click', this._onLeaveGuardOverlayClick);
      }

      this._render();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      if (this.atcButton) this.atcButton.removeEventListener('click', this._onAddToCart);
      this.removeEventListener('infinite-scroll:appended', this._onCardsAppended);

      if (this.leaveGuardEnabled && this.leaveGuardEl) {
        document.removeEventListener('click', this._onDocumentClickForLeaveGuard);
        document.removeEventListener('click', this._onDocumentCaptureForLeaveGuard, true);
        if (this.leaveGuardYesBtn) this.leaveGuardYesBtn.removeEventListener('click', this._onLeaveGuardYes);
        if (this.leaveGuardNoBtn) this.leaveGuardNoBtn.removeEventListener('click', this._onLeaveGuardNo);
        this.leaveGuardEl.removeEventListener('keydown', this._onLeaveGuardKeydown);
        this.leaveGuardEl.removeEventListener('click', this._onLeaveGuardOverlayClick);
      }
    }

    _onToggle() {
      if (!this.panel) return;
      const expanded = this.panel.classList.toggle('is-expanded');
      this.toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    _onClick(event) {
      if (event.target.closest('[data-mbo-toggle]')) {
        this._onToggle();
        return;
      }

      const card = event.target.closest('[data-mbo-card]');

      if (card) {
        const pill = event.target.closest('[data-mbo-pill]');

        if (pill) {
          this._onPillClick(card, pill);
          return;
        }

        if (event.target.closest('[data-mbo-add]')) {
          this._setQtyFromCard(card, 1);
          return;
        }

        if (event.target.closest('[data-mbo-increase]')) {
          this._setQtyFromCard(card, this._getItemQty(card.dataset.variantId) + 1);
          return;
        }

        if (event.target.closest('[data-mbo-decrease]')) {
          this._setQtyFromCard(card, this._getItemQty(card.dataset.variantId) - 1);
          return;
        }

        return;
      }

      const row = event.target.closest('[data-mbo-item]');

      if (row && event.target.closest('[data-mbo-remove]')) {
        this._setQtyById(row.dataset.variantId, 0);
      }
    }

    // The selection Map is keyed by variant id (not product id) so two
    // different variants of the same product are tracked as separate
    // entries - switching a card's variant must not merge or overwrite an
    // already-added variant's quantity.
    _getItemQty(variantId) {
      const item = this.items.get(variantId);
      return item ? item.qty : 0;
    }

    _findCard(variantId) {
      if (!this.grid) return null;
      return this.grid.querySelector('[data-mbo-card][data-variant-id="' + CSS.escape(variantId) + '"]');
    }

    _clampQty(variantId, qty, card) {
      qty = Math.max(0, qty);
      const cardEl = card || this._findCard(variantId);
      const max = cardEl ? parseInt(cardEl.dataset.maxQty, 10) : NaN;

      if (!isNaN(max) && max > 0 && qty > max) {
        qty = max;
      }

      return qty;
    }

    _onPillClick(card, pill) {
      if (pill.classList.contains('is-unavailable') || pill.getAttribute('aria-disabled') === 'true') {
        return;
      }

      let variants;

      try {
        variants = JSON.parse(card.dataset.variants || '[]');
      } catch (error) {
        return;
      }

      const row = pill.closest('[data-mbo-option-row]');

      if (row) {
        row.querySelectorAll('[data-mbo-pill]').forEach((rowPill) => {
          const isSelected = rowPill === pill;
          rowPill.classList.toggle('is-selected', isSelected);
          rowPill.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });
      }

      // Only the Size option is ever rendered as pills on this card, but a
      // product can have other options (colour, material, ...) that still
      // need a value to resolve an exact variant. Start from whichever
      // variant is currently active so those hidden dimensions carry
      // forward unchanged, then overwrite just the position that has a
      // pill row (Size).
      const currentVariant = variants.find((variant) => String(variant.id) === card.dataset.variantId);
      const selected = currentVariant ? currentVariant.options.slice() : [];

      const optionsWrap = card.querySelector('[data-mbo-options]');

      if (optionsWrap) {
        optionsWrap.querySelectorAll('[data-mbo-option-row]').forEach((optionRow) => {
          const position = parseInt(optionRow.dataset.optionPosition, 10);
          const activePill = optionRow.querySelector('[data-mbo-pill].is-selected');
          if (activePill) selected[position] = activePill.dataset.value;
        });
      }

      const matched = variants.find((variant) =>
        variant.options.every((value, index) => value === selected[index])
      );

      if (matched) {
        this._applyVariantToCard(card, matched);
      }
    }

    _applyVariantToCard(card, variant) {
      card.dataset.variantId = variant.id;
      card.dataset.available = variant.available ? 'true' : 'false';

      let maxQty = 99;

      if (variant.inventory_management === 'shopify' && variant.inventory_quantity > 0) {
        maxQty = variant.inventory_quantity;
      }

      card.dataset.maxQty = maxQty;

      this._updateCardPrice(card, variant);
      this._updateCardImage(card, variant);
      this._updateCardAvailability(card, variant);
      this._hideStockNote(card);

      // Switching variants never touches the selection Map directly - the
      // card just needs to reflect whichever quantity (if any) is already
      // stored for THIS variant, which _syncCards looks up by variant id.
      this._syncCards();
    }

    _updateCardPrice(card, variant) {
      const compareEl = card.querySelector('[data-mbo-price-compare]');
      const saleEl = card.querySelector('[data-mbo-price-sale]');
      const regularEl = card.querySelector('[data-mbo-price-regular]');
      const onSale = Boolean(variant.compare_at_price) && variant.compare_at_price > variant.price;
      const formattedPrice = this._formatMoney(variant.price);

      if (onSale) {
        if (compareEl) {
          compareEl.textContent = this._formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
        }
        if (saleEl) {
          saleEl.textContent = formattedPrice;
          saleEl.hidden = false;
        }
        if (regularEl) regularEl.hidden = true;
      } else {
        if (compareEl) compareEl.hidden = true;
        if (saleEl) saleEl.hidden = true;
        if (regularEl) {
          regularEl.textContent = formattedPrice;
          regularEl.hidden = false;
        }
      }

      card.dataset.price = formattedPrice;
      card.dataset.priceCents = variant.price;
    }

    _updateCardImage(card, variant) {
      if (!variant.featured_image || !variant.featured_image.src) return;

      const src = variant.featured_image.src;
      const img = card.querySelector('[data-mbo-image]');

      if (img) {
        img.removeAttribute('srcset');
        img.src = src;
      }

      card.dataset.image = src;
    }

    _updateCardAvailability(card, variant) {
      const addButton = card.querySelector('[data-mbo-add]');
      const badge = card.querySelector('[data-mbo-badge]');

      card.classList.toggle('mbo-card--sold-out', !variant.available);

      if (badge) badge.hidden = variant.available;

      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? this.addLabel : this.soldOutLabel;
      }
    }

    _formatMoney(cents) {
      if (window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function') {
        const format = (window.theme.settings && window.theme.settings.moneyFormat) || '${{amount}}';
        return window.theme.Currency.formatMoney(cents, format);
      }

      return '$' + (cents / 100).toFixed(2);
    }

    _showStockNote(card, max) {
      const note = card.querySelector('[data-mbo-stock-note]');
      if (!note) return;

      note.textContent = this._fillTemplate(this.stockLimitTemplate, { max: max });
      note.hidden = false;
    }

    _hideStockNote(card) {
      const note = card.querySelector('[data-mbo-stock-note]');
      if (note) note.hidden = true;
    }

    // Reads the currently selected Size pill (if the product has a Size
    // option) so it can be captured alongside the item at the moment it's
    // added, the same way price/title/image are - other options (colour,
    // material, ...) are still selectable on the card but aren't shown in
    // the panel, only Size is.
    _getVariantLabel(card) {
      const optionsWrap = card.querySelector('[data-mbo-options]');
      if (!optionsWrap) return '';

      let label = '';

      optionsWrap.querySelectorAll('[data-mbo-option-row]').forEach((row) => {
        if (label || !row.dataset.optionName || !row.dataset.optionName.toLowerCase().includes('size')) return;

        const activePill = row.querySelector('[data-mbo-pill].is-selected');
        if (activePill) label = row.dataset.optionName + ': ' + activePill.dataset.value;
      });

      return label;
    }

    _setQtyFromCard(card, requestedQty) {
      const variantId = card.dataset.variantId;
      const qty = this._clampQty(variantId, requestedQty, card);

      // The clamp above is re-evaluated against the card's current
      // data-max-qty on every single call (never cached), so a request
      // that gets capped here always means the shopper just hit the real
      // stock ceiling - surface that instead of silently doing nothing.
      if (requestedQty > 0 && qty < requestedQty) {
        this._showStockNote(card, qty);
      } else {
        this._hideStockNote(card);
      }

      if (qty <= 0) {
        this.items.delete(variantId);
      } else {
        this.items.set(variantId, {
          variantId: variantId,
          productId: card.dataset.productId,
          title: card.dataset.title,
          url: card.dataset.url,
          image: card.dataset.image || '',
          price: card.dataset.price,
          priceCents: parseInt(card.dataset.priceCents, 10) || 0,
          variantLabel: this._getVariantLabel(card),
          qty: qty
        });
      }

      this._persist();
      this._render();
    }

    _setQtyById(variantId, qty) {
      qty = this._clampQty(variantId, qty);
      const existing = this.items.get(variantId);

      if (qty <= 0) {
        this.items.delete(variantId);
      } else if (existing) {
        existing.qty = qty;
      } else {
        return;
      }

      this._persist();
      this._render();
    }

    _render() {
      this._syncCards();
      this._renderList();
      this._renderProgress();
      this._renderSummary();
      this._hideAtcError();

      if (this.atcButton) {
        this.atcButton.disabled = this.items.size === 0;
      }
    }

    _showAtcError(message) {
      if (!this.atcErrorEl) return;
      this.atcErrorEl.textContent = message || this.atcErrorText;
      this.atcErrorEl.hidden = false;
    }

    _hideAtcError() {
      if (this.atcErrorEl) this.atcErrorEl.hidden = true;
    }

    _syncCards() {
      if (!this.grid) return;

      this.grid.querySelectorAll('[data-mbo-card]').forEach((card) => {
        const qty = this._getItemQty(card.dataset.variantId);
        const addButton = card.querySelector('[data-mbo-add]');
        const qtyWrap = card.querySelector('[data-mbo-qty]');
        const qtyValue = card.querySelector('[data-mbo-qty-value]');
        const increaseBtn = card.querySelector('[data-mbo-increase]');
        const max = parseInt(card.dataset.maxQty, 10);
        const hasMax = !isNaN(max) && max > 0;

        if (qty > 0) {
          if (addButton) addButton.hidden = true;
          if (qtyWrap) qtyWrap.hidden = false;
          if (qtyValue) qtyValue.textContent = qty;
        } else {
          if (addButton) addButton.hidden = false;
          if (qtyWrap) qtyWrap.hidden = true;
          if (qtyValue) qtyValue.textContent = '0';
          this._hideStockNote(card);
        }

        // Intentionally not disabling the increase button at the cap: a
        // disabled button never fires a click, which would make the
        // stock-limit message below unreachable. It stays clickable and
        // _setQtyFromCard re-checks (and reports) the limit on every click.
        if (increaseBtn) {
          increaseBtn.classList.toggle('is-at-max', hasMax && qty >= max);
        }
      });
    }

    _renderList() {
      if (!this.list) return;

      this.list.innerHTML = '';

      if (this.items.size === 0) {
        if (this.emptyState) this.emptyState.hidden = false;
        return;
      }

      if (this.emptyState) this.emptyState.hidden = true;

      const sets = this._buildSets();
      const fragment = document.createDocumentFragment();

      sets.forEach((set) => {
        fragment.appendChild(this._buildSetBox(set));
      });

      this.list.appendChild(fragment);
    }

    // Splits each selected product's quantity across set-sized boxes so a
    // single product can span two sets (e.g. qty 4 with a set size of 3
    // shows as 3 in one box and 1 in the next).
    _buildSets() {
      const setSize = this.setSize;
      const sets = [];
      let current = { rows: [], filled: 0 };
      sets.push(current);

      this.items.forEach((item) => {
        let remaining = item.qty;

        while (remaining > 0) {
          if (current.filled >= setSize) {
            current = { rows: [], filled: 0 };
            sets.push(current);
          }

          const space = setSize - current.filled;
          const take = Math.min(space, remaining);

          current.rows.push({
            variantId: item.variantId,
            productId: item.productId,
            title: item.title,
            url: item.url,
            image: item.image,
            price: item.price,
            variantLabel: item.variantLabel,
            qty: take
          });

          current.filled += take;
          remaining -= take;
        }
      });

      return sets.filter((set) => set.rows.length > 0);
    }

    _buildSetBox(set) {
      const li = document.createElement('li');
      li.className = 'mbo-panel__set';

      const rows = document.createElement('ul');
      rows.className = 'mbo-panel__set-rows';

      set.rows.forEach((row) => {
        rows.appendChild(this._buildRow(row));
      });

      li.appendChild(rows);

      return li;
    }

    _buildRow(item) {
      const li = document.createElement('li');
      li.className = 'mbo-panel__item';
      li.setAttribute('data-mbo-item', '');
      li.dataset.variantId = item.variantId;

      const media = document.createElement('a');
      media.className = 'mbo-panel__item-media';
      media.href = item.url;
      media.tabIndex = -1;

      if (item.image) {
        const img = document.createElement('img');
        img.src = item.image;
        img.alt = '';
        img.loading = 'lazy';
        img.width = 48;
        img.height = 48;
        media.appendChild(img);
      }

      const info = document.createElement('div');
      info.className = 'mbo-panel__item-info';

      const titleLink = document.createElement('a');
      titleLink.className = 'mbo-panel__item-title';
      titleLink.href = item.url;
      titleLink.textContent = item.title;

      const meta = document.createElement('div');
      meta.className = 'mbo-panel__item-meta';

      if (item.variantLabel) {
        const variant = document.createElement('span');
        variant.className = 'mbo-panel__item-variant';
        variant.textContent = item.variantLabel;
        meta.appendChild(variant);
      }

      const price = document.createElement('span');
      price.className = 'mbo-panel__item-price';
      price.textContent = item.price;
      meta.appendChild(price);

      info.appendChild(titleLink);
      info.appendChild(meta);

      const qtyBadge = document.createElement('span');
      qtyBadge.className = 'mbo-panel__item-qty-badge';
      qtyBadge.textContent = '×' + item.qty;

      const removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'mbo-panel__item-remove';
      removeBtn.setAttribute('data-mbo-remove', '');
      removeBtn.setAttribute('aria-label', this.removeLabel);
      removeBtn.innerHTML =
        '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M3 6h18"></path>' +
        '<path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>' +
        '<path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path>' +
        '<line x1="10" y1="11" x2="10" y2="17"></line>' +
        '<line x1="14" y1="11" x2="14" y2="17"></line>' +
        '</svg>';

      li.appendChild(media);
      li.appendChild(info);
      li.appendChild(qtyBadge);
      li.appendChild(removeBtn);

      return li;
    }

    _totalQty() {
      let total = 0;
      this.items.forEach((item) => {
        total += item.qty;
      });
      return total;
    }

    _renderProgress() {
      const totalQty = this._totalQty();
      const completedSets = Math.floor(totalQty / this.setSize);
      const progressInSet = totalQty === 0 ? 0 : totalQty % this.setSize;
      const isSetBoundary = totalQty > 0 && progressInSet === 0;
      const remaining = isSetBoundary ? 0 : this.setSize - progressInSet;
      const pct = isSetBoundary ? 100 : (progressInSet / this.setSize) * 100;

      if (this.progressFill) {
        this.progressFill.style.width = pct + '%';
      }

      if (this.subtextEl) {
        if (totalQty === 0) {
          this.subtextEl.textContent = this.initialSubtext;
          this.subtextEl.hidden = !this.initialSubtext;
        } else if (remaining > 0) {
          const progressTemplate = completedSets > 0 ? this.progressTemplateRepeat : this.progressTemplateFirst;
          this.subtextEl.textContent = this._fillTemplate(progressTemplate, {
            remaining: remaining
          });
          this.subtextEl.hidden = false;
        } else {
          this.subtextEl.hidden = true;
        }
      }

      if (this.strip) {
        if (completedSets > 0) {
          const stripTemplate = completedSets === 1 ? this.stripTemplateSingular : this.stripTemplatePlural;
          this.strip.textContent = this._fillTemplate(stripTemplate, {
            count: completedSets,
            set_size: this.setSize
          });
          this.strip.hidden = false;
        } else {
          this.strip.hidden = true;
        }
      }

      if (this.panel) {
        this.panel.classList.toggle('has-items', totalQty > 0);
      }
    }

    // Subtotal is always visible, even at zero items. Every COMPLETE set is
    // valued at the flat set price, while any leftover units sitting in the
    // trailing, not-yet-complete set are valued at their real price -
    // mirroring exactly how _buildSets fills boxes left-to-right in the
    // same Map insertion order, so this always matches what the panel
    // visually shows. The strikethrough/savings only appear once that
    // actually produces a discount (i.e. at least one complete set).
    _renderSummary() {
      if (!this.summaryEl) return;

      const totalQty = this._totalQty();
      const completedSets = Math.floor(totalQty / this.setSize);

      let originalTotal = 0;
      this.items.forEach((item) => {
        originalTotal += item.priceCents * item.qty;
      });

      let payableTotal = originalTotal;

      if (completedSets > 0 && this.setPriceCents) {
        const leftoverUnits = totalQty % this.setSize;
        let leftoverValue = 0;
        let unitsToSkip = totalQty - leftoverUnits;

        this.items.forEach((item) => {
          let qty = item.qty;

          if (unitsToSkip > 0) {
            const skip = Math.min(unitsToSkip, qty);
            unitsToSkip -= skip;
            qty -= skip;
          }

          leftoverValue += item.priceCents * qty;
        });

        payableTotal = completedSets * this.setPriceCents + leftoverValue;
      }

      const savings = Math.max(0, originalTotal - payableTotal);
      const savingsPercent = originalTotal > 0 ? Math.round((savings / originalTotal) * 100) : 0;
      const hasDiscount = savingsPercent > 0;

      if (this.summaryCompareRowEl) this.summaryCompareRowEl.hidden = !hasDiscount;
      if (this.summaryCompareEl) this.summaryCompareEl.textContent = this._formatMoney(originalTotal);

      if (this.summaryTotalEl) {
        this.summaryTotalEl.textContent = this._formatMoney(payableTotal);
      }

      if (this.summarySavingsEl) {
        if (hasDiscount) {
          this.summarySavingsEl.textContent = this._fillTemplate(this.savingsTemplate, {
            percent: savingsPercent,
            amount: this._formatMoney(savings)
          });
          this.summarySavingsEl.hidden = false;
        } else {
          this.summarySavingsEl.hidden = true;
        }
      }
    }

    _fillTemplate(template, values) {
      return Object.keys(values).reduce((text, key) => {
        const pattern = new RegExp('\\[\\s*' + key + '\\s*\\]', 'g');
        return text.replace(pattern, values[key]);
      }, template);
    }

    // Shared by both listeners below: resolves a raw href/data-link value
    // into a real, cross-origin-safe destination worth guarding, or null if
    // it isn't (blank, hash-only, non-http, or just an anchor within this
    // same page).
    _resolveLeaveGuardDestination(href) {
      if (!href || href.charAt(0) === '#') return null;

      let destination;
      try {
        destination = new URL(href, window.location.href);
      } catch (error) {
        return null;
      }

      if (destination.protocol !== 'http:' && destination.protocol !== 'https:') return null;

      const isSamePageAnchor = destination.href.split('#')[0] === window.location.href.split('#')[0] && destination.hash;
      if (isSamePageAnchor) return null;

      return destination.href;
    }

    _isModifiedClick(event) {
      return event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
    }

    // Guards against navigating away from the page while items are staged
    // in the panel but not yet added to the cart. Only reacts to <a> clicks
    // that would actually unload this page - see the bubble-phase note
    // where the listener is attached for why drawer/ajax-handled clicks are
    // naturally excluded without needing to special-case them here.
    _onDocumentClickForLeaveGuard(event) {
      if (this.items.size === 0 || !this.leaveGuardEl.hidden) return;
      if (event.defaultPrevented || this._isModifiedClick(event)) return;

      const link = event.target.closest('a[href]');
      if (!link || link.closest('.pagination')) return;
      if (link.target && link.target !== '_self') return;

      const destination = this._resolveLeaveGuardDestination(link.getAttribute('href') || '');
      if (!destination) return;

      event.preventDefault();
      this._showLeaveGuard(destination);
    }

    // This theme's own top-level dropdown nav items ("Top Wear" etc.) are a
    // <details>/<summary data-link> pair, not an <a> - theme.js binds a
    // click listener directly on the <summary> that calls preventDefault()
    // and does window.location.href = ... itself, entirely bypassing a
    // normal link click. That handler always runs before any bubble-phase
    // document listener (and preventDefault() there doesn't stop it - it
    // only suppresses the native <details> toggle), so the only way to
    // guard these is to catch the click earlier, in the capture phase, and
    // stopPropagation() so it never reaches that handler at all.
    _onDocumentCaptureForLeaveGuard(event) {
      if (this.items.size === 0 || !this.leaveGuardEl.hidden) return;
      if (this._isModifiedClick(event)) return;

      const summary = event.target.closest('summary[data-link]');
      if (!summary) return;

      const destination = this._resolveLeaveGuardDestination(summary.dataset.link || '');
      if (!destination) return;

      event.preventDefault();
      event.stopPropagation();
      this._showLeaveGuard(destination);
    }

    _showLeaveGuard(destinationUrl) {
      this.pendingLeaveGuardUrl = destinationUrl;

      const count = Array.from(this.items.values()).reduce((total, item) => total + item.qty, 0);
      if (this.leaveGuardMessageEl) {
        this.leaveGuardMessageEl.textContent = this._fillTemplate(this.leaveGuardMessageTemplate, { count: count });
      }

      this.leaveGuardLastFocusedEl = document.activeElement;
      this.leaveGuardEl.hidden = false;
      document.documentElement.classList.add('mbo-leave-guard-open');

      if (this.leaveGuardYesBtn) this.leaveGuardYesBtn.focus();
    }

    _hideLeaveGuard() {
      this.leaveGuardEl.hidden = true;
      document.documentElement.classList.remove('mbo-leave-guard-open');

      if (this.leaveGuardLastFocusedEl && typeof this.leaveGuardLastFocusedEl.focus === 'function') {
        this.leaveGuardLastFocusedEl.focus();
      }
      this.leaveGuardLastFocusedEl = null;
    }

    // Clicking the backdrop closes the popup without deciding anything -
    // the shopper stays on this page with their items still staged, same
    // as if they'd never clicked the link that opened it. Only fires for a
    // click that never reached the dialog box itself.
    _onLeaveGuardOverlayClick(event) {
      if (event.target.closest('[data-mbo-leave-guard-dialog]')) return;
      if (this.leaveGuardBusy) return;

      this._hideLeaveGuard();
      this.pendingLeaveGuardUrl = '';
    }

    // Traps Tab inside the two buttons and swallows Escape - the dialog
    // still only resolves via Yes/No or the backdrop click above, never a
    // stray keypress.
    _onLeaveGuardKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        return;
      }

      if (event.key !== 'Tab') return;

      const focusable = [this.leaveGuardYesBtn, this.leaveGuardNoBtn].filter(Boolean);
      if (focusable.length < 2) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    async _resolveLeaveGuard(shouldAddToCart) {
      if (this.leaveGuardBusy) return;

      const destination = this.pendingLeaveGuardUrl;

      if (!shouldAddToCart) {
        this._hideLeaveGuard();
        this.items.clear();
        this._persist();
        this._render();
        if (this.panel) this.panel.classList.remove('is-expanded');
        if (this.toggle) this.toggle.setAttribute('aria-expanded', 'false');
        this.pendingLeaveGuardUrl = '';
        if (destination) window.location.href = destination;
        return;
      }

      this.leaveGuardBusy = true;
      if (this.leaveGuardYesBtn) {
        this.leaveGuardYesBtn.disabled = true;
        this.leaveGuardYesBtn.classList.add('is-loading');
      }
      if (this.leaveGuardNoBtn) this.leaveGuardNoBtn.disabled = true;

      const added = await this._onAddToCart();

      this.leaveGuardBusy = false;
      if (this.leaveGuardYesBtn) {
        this.leaveGuardYesBtn.disabled = false;
        this.leaveGuardYesBtn.classList.remove('is-loading');
      }
      if (this.leaveGuardNoBtn) this.leaveGuardNoBtn.disabled = false;

      this._hideLeaveGuard();
      this.pendingLeaveGuardUrl = '';

      const cartTypeIsPage = window.theme && window.theme.settings && window.theme.settings.cartType === 'page';

      // A successful add already redirects to the cart page itself when
      // cartType is "page" (see _onAddToCart) - don't also race it to the
      // originally-clicked destination. A failed add leaves the shopper on
      // this page with the panel's own error message so they can fix the
      // quantity and retry, instead of silently losing their selection.
      if (added && !cartTypeIsPage && destination) {
        window.location.href = destination;
      }
    }

    _persist() {
      try {
        sessionStorage.setItem(this.storageKey, JSON.stringify(Array.from(this.items.values())));
      } catch (error) {
        /* storage unavailable (private mode, quota) - selections just won't survive a reload */
      }
    }

    _restore() {
      try {
        const raw = sessionStorage.getItem(this.storageKey);
        if (!raw) return;

        const data = JSON.parse(raw);
        if (!Array.isArray(data)) return;

        data.forEach((item) => {
          if (item && item.variantId) {
            this.items.set(String(item.variantId), item);
          }
        });
      } catch (error) {
        /* corrupt/blocked storage - start from an empty selection */
      }
    }

    // Attaches this offer's display config (group key, colour, messages,
    // redirect link) as hidden line item properties on every item it adds.
    // The cart template has no access to this section's settings - it's a
    // separate render context entirely - so this is how that config
    // travels along with the cart items themselves. Underscore-prefixed
    // properties are automatically hidden from the customer at cart and
    // checkout (a documented Shopify convention, also already relied on
    // by this theme's own cart-item.liquid).
    _buildCartGroupProperties() {
      if (!this.cartGroupKey) return null;

      return {
        _mbo_offer: this.cartGroupKey,
        _mbo_collection_id: this.collectionId,
        _mbo_collection_handle: this.collectionHandle,
        _mbo_set_size: String(this.setSize),
        _mbo_set_price: String(this.setPriceCents),
        _mbo_bg: this.cartGroupBg,
        _mbo_msg_first: this.cartGroupMessageFirst,
        _mbo_msg_repeat: this.cartGroupMessageRepeat,
        _mbo_msg_singular: this.cartGroupMessageSingular,
        _mbo_msg_plural: this.cartGroupMessagePlural,
        _mbo_redirect: this.cartGroupRedirectUrl
      };
    }

    async _onAddToCart() {
      if (this.items.size === 0 || this.atcButton.disabled) return false;

      const cartGroupProperties = this._buildCartGroupProperties();

      const items = Array.from(this.items.values()).map((item) => {
        const payload = {
          id: parseInt(item.variantId, 10),
          quantity: item.qty
        };

        if (cartGroupProperties) {
          payload.properties = cartGroupProperties;
        }

        return payload;
      });

      this._hideAtcError();
      this.atcButton.disabled = true;
      this.atcButton.classList.add('is-loading');

      try {
        const response = await fetch(this.cartAddUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items: items })
        });

        if (!response.ok) {
          const errorPayload = await response.json().catch(() => null);
          throw errorPayload || new Error('Unable to add items to cart.');
        }

        let cart = null;

        try {
          const cartResponse = await fetch(this.cartUrl, { credentials: 'same-origin' });
          cart = await cartResponse.json();
        } catch (error) {
          cart = null;
        }

        this.items.clear();
        this._persist();
        this._render();

        if (this.panel) this.panel.classList.remove('is-expanded');
        if (this.toggle) this.toggle.setAttribute('aria-expanded', 'false');

        if (window.theme && window.theme.settings && window.theme.settings.cartType === 'page') {
          window.location = (window.theme.routes && window.theme.routes.cartPage) || '/cart';
          return true;
        }

        if (cart) {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        }

        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        return true;
      } catch (error) {
        const isCartRejection = error && typeof error === 'object' && !(error instanceof Error);

        if (!isCartRejection) {
          console.error('Multi-buy offer: failed to add items to cart', error);
        }

        const detail = isCartRejection ? error.description || error.message : null;
        this._showAtcError(typeof detail === 'string' && detail ? detail : this.atcErrorText);
        return false;
      } finally {
        this.atcButton.disabled = this.items.size === 0;
        this.atcButton.classList.remove('is-loading');
      }
    }
  }

  customElements.define('multi-buy-offer', MultiBuyOffer);
}
